<!-- @format -->
<div class="dialog-max cdialog min-w-[450px]">
  <div class="dialogHeader">
    <h2 mat-dialog-title>{{_common.select_booking}}
    </h2>
    <div class="spacer"></div>

    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content>
    <div class="dialogBody">
      <div *ngFor="let s of objects" (click)="open(s)" class="flex flex-col gap-2">
        <div class="card cursor-pointer hover:bg-gray-50">
          <div class="cardBody w-full">
            <div class="flex">
              <div class="spacer">{{ dateText(s) }}</div>
              <div class="text-xs text-gray-500">#{{s.bookingNo}} </div>
            </div>
            <div>{{s.startTime.format("hh:mm a")}} - {{s.endTime.format("hh:mm a")}}</div>

            <div>{{1 + s.numParticipants}} {{_common.participant_users}}</div>
            <div>{{_common.BookingPerson}}: {{s.member?.name}}</div>



          </div>

        </div>

      </div>

    </div>
  </mat-dialog-content>

</div>